import { render, staticRenderFns } from "./checkresultdetail.vue?vue&type=template&id=04dc3404&"
import script from "./checkresultdetail.vue?vue&type=script&lang=js&"
export * from "./checkresultdetail.vue?vue&type=script&lang=js&"
import style0 from "./checkresultdetail.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports